import { render, staticRenderFns } from "./btn_edition_suppression_mini.vue?vue&type=template&id=f8adf4ae"
import script from "./btn_edition_suppression_mini.js?vue&type=script&lang=js&external"
export * from "./btn_edition_suppression_mini.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports